import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { TaskAuditDataDetailInterface } from './definitions/task-audit-data-detail.interface';

@Injectable()
export class GetTaskAuditDataDetailService {
  constructor(
    private client: HttpClient,
    private configService: ConfigService
  ) {}

  public getAuditDataDetail(
    taskId: string,
    auditLogId: number
  ): Observable<TaskAuditDataDetailInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/audit/${auditLogId}`;

    return this.client
      .get<TaskAuditDataDetailInterface>(url)
      .pipe(catchError((error) => throwError(() => handleProblem(error))));
  }
}
